<script>
import options from './FormStepSubmitting.options'
export default options
</script>

<template>
  <article class="kb-form-step-submitting">
    <template v-if="loading">
      <div class="kb-spinner-overlay">
        <div class="kb-spinner-overlay__spinner"></div>
      </div>
    </template>

    <template v-if="errorMessage !== ''">
      <article class="kb-single-content-spot kb-single-content-spot--no-icon">
        <div class="kb-single-content-spot__decoration"></div>

        <div class="kb-single-content-spot__content">
          <h2 class="kb-single-content-spot__title">
            {{ labels.submitErrorTitle }}
          </h2>
          <p class="kb-single-content-spot__text-content">
            {{ labels.submitErrorMessage }}
          </p>
        </div>
        <div class="kb-single-content-spot__button-wrapper">
          <div>
            <button
              v-on:click="previousStepCallback"
              class="kb-button kb-button--full-color-spot"
            >
              {{ labels.submitReturnButtonText }}
            </button>
            <button
              v-on:click="submitRetry"
              class="kb-button kb-button--spot-border-color kb-single-content-spot kb-button--spot-border-color"
            >
              {{ labels.submitRetryButtonText }}
            </button>
          </div>
        </div>
      </article>
    </template>
  </article>
</template>
